<template>
  <section class="suspension">
    <a @mouseenter="showTooltip(0)" @mouseleave="hideTooltip">
      微信咨询
      <div class="inner-box" v-show="activeTooltip === 0">
        <i>&nbsp;</i>
        <img src="https://new-official.dev-01.54test.cn/Home/images/weixinqiye.png" height="119" width="121">
        <h4>扫码添加官方客服 为您提供专属答疑</h4>
      </div>
    </a>
    <a @click="openOnlineChat">在线客服</a>
    <a @mouseenter="showTooltip(2)" @mouseleave="hideTooltip">
      员工服务
      <div class="inner-box" v-show="activeTooltip === 2">
        <i>&nbsp;</i>
        <img src="https://new-official.dev-01.54test.cn/Home/images/newweixingzh.jpeg" height="119" width="121">
        <h4>扫码关注泛亚人力 随时随地自助查询</h4>
      </div>
    </a>
    <a href="https://new-official.dev-01.54test.cn/salarycalculation" target="_blank">国际薪酬测算</a>
    <a @mouseenter="showTooltip(4)" @mouseleave="hideTooltip" href="https://www.wjx.cn/vj/QSa6of3.aspx" target="_blank">
      投诉建议
      <div class="inner-box" v-show="activeTooltip === 4">
        <i>&nbsp;</i>
        <img src="https://new-official.dev-01.54test.cn/Home/images/泛睿集团-投诉提交表二维码（512x512）.jpg" height="119" width="121">
        <h4>投诉提交表</h4>
      </div>
    </a>
  </section>
</template>

<script>
export default {
  name: 'Suspension',
  data() {
    return {
      activeTooltip: -1
    }
  },
  methods: {
    showTooltip(index) {
      this.activeTooltip = index
    },
    hideTooltip() {
      this.activeTooltip = -1
    },
    openOnlineChat() {
      if (window.ECHAT) {
        window.ECHAT.customMiniChat()
      } else {
        alert('在线客服功能正在维护中，请稍后再试')
      }
    }
  }
}
</script>

<style scoped>
.suspension {
  position: fixed;
  right: 0;
  top: 30%;
  width: 120px;
  background: #fff;
  border: 1px solid #eee;
  border-top: 0;
  z-index: 9999999;
}

.suspension a {
  position: relative;
  display: block;
  height: 80px;
  font-size: 12px;
  color: #8d92a1 !important;
  text-align: center;
  cursor: pointer;
  line-height: 120px;
  background: url("https://new-official.dev-01.54test.cn/Home/images/suspension-bg.png") left 0 no-repeat;
  outline: none;
  border-top: 1px solid #eee;
  transition: all 0.3s ease;
  background-position: 50% 0%;
}

.suspension a:hover {
  background: #ff424f url("https://new-official.dev-01.54test.cn/Home/images/suspension-bgs.png") left 0 no-repeat;
  color: #fff;
  background-position: 50% 0%;
}

.suspension a:nth-child(2) {
  background: url("https://new-official.dev-01.54test.cn/Home/images/suspension-bg.png") left -240px no-repeat;
  background-position: 50%;
}

.suspension a:nth-child(2):hover {
  background: #ff424f url("https://new-official.dev-01.54test.cn/Home/images/suspension-bgs.png") left -240px no-repeat;
  background-position: 50%;
}

.suspension a:nth-child(3) {
  background: url("https://new-official.dev-01.54test.cn/Home/images/suspension-bg1.png") left -160px no-repeat;
  background-position: 50%;
}

.suspension a:nth-child(3):hover {
  background: #ff424f url("https://new-official.dev-01.54test.cn/Home/images/suspension-bgs1.png") left -160px no-repeat;
  background-position: 50%;
}

.suspension a:nth-child(4) {
  background: url("https://new-official.dev-01.54test.cn/Home/images/salary-calc-icon.png") no-repeat center center;
  background-position: 50% 22%;
}

.suspension a:nth-child(4):hover {
  background: #ff424f url("https://new-official.dev-01.54test.cn/Home/images/salary-calc-icon.png") no-repeat center center;
  background-position: 50% 22%;
}

.suspension a:nth-child(5) {
  background: url("https://new-official.dev-01.54test.cn/Home/images/suspension-bg.png") left -162px no-repeat;
  background-position: 50%;
}

.suspension a:nth-child(5):hover {
  background: #ff424f url("https://new-official.dev-01.54test.cn/Home/images/suspension-bgs.png") left -162px no-repeat;
  background-position: 50%;
}

.suspension a:hover .inner-box {
  display: block;
}

.inner-box {
  display: none;
  padding: 10px 20px;
  width: 160px;
  background: #fff;
  position: absolute;
  right: 90px;
  top: 0;
  border: 1px solid #E0E1E5;
  border-radius: 3px;
  box-shadow: 0px 2px 5px 0px rgba(161, 163, 175, 0.11);
  z-index: 10000;
}

.inner-box i {
  position: absolute;
  width: 8px;
  height: 12px;
  background: url("https://new-official.dev-01.54test.cn/Home/images/side_bg_arrow.png") no-repeat;
  right: -8px;
  top: 31px;
}

.inner-box img {
  display: inline-block;
  vertical-align: middle;
}

.inner-box h4 {
  display: block;
  line-height: normal !important;
  color: #5e6d82;
  font-size: 16px;
}
</style>
